__webpack_require__.p = "//release.digitkart.ai/";